import React, { FC, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import ENLocalize from "./en.json";
import DELocalize from "./de.json";

const appAvailableLocales = ["en", "de"];
const DEFAULT_LOCALE = appAvailableLocales[0];

const localizeToMessagesMapping: Record<string, typeof ENLocalize> = {
    en: ENLocalize,
    de: DELocalize,
};
const browserLocale = navigator.language;

const loadMessages = async (locale: string): Promise<typeof ENLocalize> => {
    return new Promise((resolve) =>
        resolve(localizeToMessagesMapping[locale] || localizeToMessagesMapping[DEFAULT_LOCALE]),
    );
};

const Localization: FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [messages, setMessages] = useState<any>();
    const [currentLocale, setCurrentLocale] = useState<string>("");
    useEffect(() => {
        const currentBrowserLocale = browserLocale;
        setCurrentLocale(currentBrowserLocale);
    }, []);
    useEffect(() => {
        if (currentLocale) {
            loadMessages(currentLocale).then((value) => setMessages(value));
        }
    }, [currentLocale]);
    return (
        <IntlProvider locale={currentLocale} messages={messages}>
            {children}
        </IntlProvider>
    );
};

export default Localization;
